import { Flame } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  const doubled = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section
      aria-label="Specialties"
      className="overflow-hidden border-y border-amber-500/10 bg-coal py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap font-serif text-lg uppercase tracking-[0.2em] text-amber-100/60">
              {item}
            </span>
            <Flame
              className="mx-8 size-4 shrink-0 text-ember/70"
              strokeWidth={1.5}
            />
          </span>
        ))}
      </div>
    </section>
  );
}
